@if (loading()) {
  <app-loading />
} @else {
  <app-step-dot-menu
    [projectId]="projectId()!"
    testId="step4-2-x-dot-menu-button"
    [preselectedRole]="ProjectRoleType.CONTRIBUTOR"
    [preselectedAccessiblePages]="[ProjectStepType.EVALUATION_SUB_CRITERIA]"
  ></app-step-dot-menu>

  <div class="mt-5" data-testid="sub-criteria-evaluation-x-page">
    @if (hasTabs()) {
      <p-tabs
        appTabsUnsavedReveal
        lazy
        scrollable
        [value]="activeTabIndex()"
        (valueChange)="onTabChange($event)"
        data-testid="sub-criteria-x-tabs"
      >
        <p-tablist>
          @for (tab of tabs(); track tab.id; let index = $index) {
            <p-tab
              [value]="index"
              [appTabStatus]="tab.status"
              [appTabStatusUnsaved]="tab.hasUnsavedChanges"
              [attr.data-testid]="'sub-criteria-x-tab-' + tab.id"
            >
              {{ tab.translations | translateDirectus }}
            </p-tab>
          }
        </p-tablist>

        <p-tabpanels class="mt-6">
          @for (tab of tabs(); track tab.id; let index = $index) {
            <p-tabpanel [value]="index" [attr.data-testid]="'sub-criteria-x-tabpanel-' + tab.id">
              <app-sub-criteria-tab-x
                [tab]="tab"
                [comparisons]="comparisonsByCriteriaId().get(tab.id) ?? []"
                [weighting]="weightingByCriteriaId().get(tab.id) ?? null"
                [auditInfo]="auditInfo()"
                [disabled]="isButtonDisabled()"
                [saving]="isSaving()"
                [subCriteriaLoading]="subCriteriaLoading()"
                (inclusionsSave)="onInclusionsSave($event)"
                (comparisonsSave)="onComparisonsSave($event)"
                (weightingSave)="onWeightingSave(tab.id, $event)"
              ></app-sub-criteria-tab-x>
            </p-tabpanel>
          }
        </p-tabpanels>
      </p-tabs>
    } @else {
      <div class="card text-center py-12" data-testid="sub-criteria-x-no-criteria">
        <i class="pi pi-info-circle text-4xl mb-4"></i>
        <h3 class="text-lg font-semibold mb-2">
          {{ 'project.steps.noCriteriaTitle' | transloco }}
        </h3>
        <p class="max-w-md mx-auto">{{ 'project.steps.noCriteriaMessage' | transloco }}</p>
      </div>
    }
  </div>
}
